export default __webpack_public_path__ + "static/media/present.2b890fca.webp";